import { connect } from 'react-redux'
import TripsHistoryHeader from '../../components/trips/TripsHistoryHeader'
import { getTripsHistoryColumns } from '../../state/selectors/index'
import { IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    columns: getTripsHistoryColumns(state)
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripsHistoryHeader)



// WEBPACK FOOTER //
// ./src/containers/trips/TripsHistoryHeader.ts